// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { IconWrapper } from "@insite/mobius/Icon";
import { TypographyProps } from "@insite/mobius/Typography";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { cartFulfillmentMethodStyles } from "@plumberssupply/Overrides/Widgets/Cart/CartFulfillmentMethodSelector";
import IconEdit from "@plumberssupply/XDL/Icons/IconEdit";
import { color, iconLinkCommonStyles, mergeWithCss } from "@plumberssupply/XDL/Utilities";
import { css } from "styled-components";

cartFulfillmentMethodStyles.fulfillmentMethodradioGroup = {
    css: css`
        &&&& {
            legend {
                color: ${color("common.ui11")};
                font-size: 14px;
                line-height: 18px;
                font-weight: 800;
            }

            label {
                font-size: 12px;
                line-height: 15px;
            }
        }
    `,
};

const addressDetailsStyles: TypographyProps = {
    as: "p",
    size: 12,
    lineHeight: "15px",
    css: css`
        margin: 0;
    `,
};

cartFulfillmentMethodStyles.pickUpLocation = {
    wrapper: {
        css: css`
            margin-left: 30px;
        `,
    },
    headerText: {
        weight: "bold",
        size: 12,
        lineHeight: "15px",
    },
    changeLink: {
        ...mergeWithCss(iconLinkCommonStyles(IconEdit), {
            css: css`
                ${TypographyStyle} {
                    display: none;
                }

                ${IconWrapper} {
                    &,
                    & svg {
                        width: 12px;
                        height: 13px;
                    }
                }
            `,
        }),
    },
    warehouseAddress: {
        wrapper: {
            css: css`
                margin: 0;
            `,
        },
        nameText: {
            size: 12,
        },
        address: {
            customerNameText: { ...addressDetailsStyles },
            attentionText: { ...addressDetailsStyles },
            companyNameText: { ...addressDetailsStyles },
            address1Text: { ...addressDetailsStyles },
            address2Text: { ...addressDetailsStyles },
            address3Text: { ...addressDetailsStyles },
            address4Text: { ...addressDetailsStyles },
            cityStatePostalCodeText: { ...addressDetailsStyles },
            countryText: { ...addressDetailsStyles },
            phoneText: { ...addressDetailsStyles },
            emailText: { ...addressDetailsStyles },
            faxText: { ...addressDetailsStyles },
        },
    },
};

cartFulfillmentMethodStyles.loadingOverlay = {
    css: css`
        width: 100%;
    `,
};
